import { Controller } from "@hotwired/stimulus";

// Share button on a member's own profile (Jacob's layout page 8, #28). Uses the
// browser's share sheet where there is one (phones, Safari), otherwise copies
// the profile URL to the clipboard and says so on the button for two seconds.
export default class extends Controller {
  static targets = ["label"];
  static values = { url: String, title: String, copied: String };

  share(event) {
    event.preventDefault();
    const data = { title: this.titleValue, url: this.urlValue };

    if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
      navigator.share(data).catch(() => {});
      return;
    }

    this.copy();
  }

  copy() {
    const done = () => this.flash();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.urlValue).then(done).catch(() => this.fallbackCopy(done));
    } else {
      this.fallbackCopy(done);
    }
  }

  fallbackCopy(done) {
    const area = document.createElement("textarea");
    area.value = this.urlValue;
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    try { document.execCommand("copy"); } catch (_) { /* nothing to do */ }
    document.body.removeChild(area);
    done();
  }

  flash() {
    if (!this.hasLabelTarget) return;
    const original = this.labelTarget.textContent;
    this.labelTarget.textContent = this.copiedValue;
    setTimeout(() => { this.labelTarget.textContent = original; }, 2000);
  }
}
